import React from 'react'
import styled from '@emotion/styled'
import { getContrast, getLuminance } from 'polished'

const getFontColor = color => {
  return getLuminance(`${color}`) > 0.5 ? '#000' : '#fff'
}

const Alternativa = ({
  enunciado,
  color,
  index,
  mode = 'full',
  children,
  porcion,
  total,
  simple = false,
}) => {
  const letter = String.fromCharCode(97 + index)
  return (
    <AlternativaMode color={color} mode={mode} porcion={porcion} total={total}>
      {mode === 'full' && (
        <>
          {!simple && <span>{letter}. </span>}
          <span
            dangerouslySetInnerHTML={{
              __html: enunciado !== 'null' ? enunciado : 'No definido',
            }}></span>
          {children}
        </>
      )}
    </AlternativaMode>
  )
}

const AlternativaMode = ({
  mode = 'full',
  porcion,
  total,
  children,
  color,
  ...rest
}) => {
  if (mode === 'bar') {
    const amount = (porcion / total) * 100

    return (
      <StyledBarra
        style={{ width: `${amount.toFixed(2)}%` }}
        bgColor={color}
        {...rest}>
        {children}
      </StyledBarra>
    )
  }

  return (
    <StyledAlternativa bgColor={color} {...rest}>
      {children}
    </StyledAlternativa>
  )
}

const StyledAlternativa = styled.div`
  border: 1px solid black;
  margin-bottom: 1rem;
  padding: 1rem 5rem 1rem 1rem;
  border: 1px solid black;
  box-shadow: 3px 4px 0 0 black;
  border-radius: 3px;
  background-color: ${props => props.bgColor || '#f0faff'};
  text-align: left;
  line-height: 1;
  transition: all 0.2s;
  color: ${props =>
    props.bgColor
      ? getContrast(`${props.bgColor}`, `#000`) <= 8
        ? getFontColor(props.bgColor)
        : '#000'
      : '#000'};
  /* opacity: 0; */
  /* &:hover {
    box-shadow: 6px 7px 0 0 black;
  } */
  position: relative;
  .porcentaje {
    position: absolute;
    right: 8px;
    top: 0;
    bottom: 0;
    width: 4.5rem;
    display: flex;
    align-items: center;
    line-height: 1;
    letter-spacing: -1px;
    text-align: right;
    font-weight: bold;
    font-size: 1.5rem;
    color: ${props =>
      props.bgColor
        ? getContrast(`${props.bgColor}`, `#000`) <= 6
          ? getFontColor(props.bgColor)
          : '#000'
        : '#000'};
  }
`

const StyledBarra = styled.div`
  padding: 0;
  /* overflow: hidden; */
  background-color: ${props => props.bgColor || '#f0faff'};
  text-align: left;
  line-height: 1;
  transition: all 0.2s;
  width: ${props => (props.width ? `${props.width}` : `100%`)};
  color: ${props =>
    props.bgColor
      ? getContrast(`${props.bgColor}`, `#000`) <= 6
        ? getFontColor(props.bgColor)
        : '#000'
      : '#000'};
  /* opacity: 0; */
  /* &:hover {
    box-shadow: 6px 7px 0 0 black;
  } */
  position: relative;
  .porcentaje {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 4rem;
    h4 {
      font-size: 1rem;
      line-height: 1;
    }
  }
`

export default Alternativa
